import { Component } from 'react';
/**
 * Abstract component to display a list of chat messages, grouped by sender.
 *
 * @augments PureComponent
 */
class AbstractMessageContainer extends Component {
    /**
     * Iterates over all the messages and creates nested arrays which hold
     * consecutive messages sent by the same participant.
     *
     * @private
     * @returns {Array<Array<Object>>}
     */
    _getMessagesGroupedBySender() {
        const messagesCount = this.props.messages.length;
        const groups = [];
        let currentGrouping = [];
        let currentGroupParticipantId = "";
        for (let i = 0; i < messagesCount; i++) {
            const message = this.props.messages[i];
            const composeName = message.participantId + (message.originSenderAccName || "");
            if (composeName === currentGroupParticipantId) {
                currentGrouping.push(message);
            }
            else {
                currentGrouping.length && groups.push(currentGrouping);
                currentGrouping = [message];
                currentGroupParticipantId = composeName;
            }
        }
        currentGrouping.length && groups.push(currentGrouping);
        return groups;
    }
    /**
    * Iterates over all the messages and creates nested arrays which hold
    * consecutive messages sent by the same participant in a while.
    *
    * @private
    * @returns {Array<Array<Object>>}
    */
    _getMessagesGroupedBySenderAndTime() {
        const messages = [...this.props.messages].sort((a, b) => a.timestamp - b.timestamp);
        const messagesCount = messages.length;
        const groups = [];
        let currentGrouping = [];
        let currentGroupParticipantId = "";
        let isCurrentPrivateMessage = false;
        let currentTimestamp = Date.now();
        let currentRecipient = "";
        const fiveMinutes = 300000;
        for (let i = 0; i < messagesCount; i++) {
            const message = messages[i];
            message.attachments = message.attachments?.map(a => ({ ...a, messageType: message.messageType }));
            const composeName = message.participantId + (message.originSenderAccName || "");
            if (composeName === currentGroupParticipantId
                && message.privateMessage === isCurrentPrivateMessage
                && message.recipient === currentRecipient
                && message.timestamp - currentTimestamp < fiveMinutes) {
                currentGrouping.push(message);
                currentTimestamp = message.timestamp;
            }
            else {
                currentGrouping.length && groups.push(currentGrouping);
                currentGrouping = [message];
                currentGroupParticipantId = composeName;
                isCurrentPrivateMessage = message.privateMessage;
                currentTimestamp = message.timestamp;
                currentRecipient = message.recipient;
            }
        }
        currentGrouping.length && groups.push(currentGrouping);
        return groups;
    }
}
AbstractMessageContainer.defaultProps = {
    messages: []
};
export default AbstractMessageContainer;
